<aside [style.width]="panelWidth()" class="mat-select-for-filter-component">
  <mat-card class="filter-card">
    <mat-card-header>
      <mat-card-title>{{ label() }}</mat-card-title>
      <button class="refresh-button" (click)="onRefresh()" >
        <span>{{ 'filter.reset' | transloco }}</span>
      </button>
    </mat-card-header>

    <mat-card-content>
      @for (selectGroup of selectItemGroups(); track selectGroup) {
        <span class="filter-item-title">{{ selectGroup.parent | transloco }}</span>
        <mat-form-field>
          <mat-select placeholder="{{ selectGroup.parent | transloco }}" [formControl]="selectControls[selectGroup.parent]">
            @for (childItem of selectGroup.children; track childItem) {
              <mat-option [value]="childItem">{{ childItem | transloco }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @for (searchGroup of searchItemGroups(); track searchGroup) {
        <span class="filter-item-title">{{ searchGroup.title | transloco }}</span>
        <mat-form-field>
          <span style="display: flex">
            <input matInput [formControl]="searchControls[searchGroup.title]" placeholder="{{ searchGroup.title | transloco }}">
            <mat-icon>search</mat-icon>
          </span>
        </mat-form-field>
      }
    </mat-card-content>
  </mat-card>
</aside>

